import React from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import iconSettings from "../../../../../images/icon-settings.svg";
import {LogOut} from "./Logout";
import settingsActions from "./settingsActions";
import {logAction} from "../../../../logging/logEvent";
import HeaderButton from "../buttons/HeaderButton";

const SettingsIcon = styled.img`
    width: 20px;
    height: 20px;
`;

const MenuContainer = styled.div`
    position: absolute;
    width: 0;
    height: 0;
`;

const Menu = styled.div`
    position: relative;
    top: 24px;
    right: 112px;
    display: flex;
    align-items: center;
    width: 126px;
    height: 32px;
    border: solid 1px #e2dede;
    background-color: rgba(255, 255, 255, 0.8);
`;

const Settings = ({}) => {
    const show = useSelector(state => state.settings.show);
    const dispatch = useDispatch();

    function onClick() {
        logAction({
            type: "SETTINGS_MENU_CLICKED",
            openOrClose: show ? "close" : "open"
        });
        settingsActions(dispatch).toggleSettingsMenu(!show);
    }

    const menuComponent = !show ? null : (
        <MenuContainer>
            <Menu>
                <LogOut/>
            </Menu>
        </MenuContainer>
    );

    return (
        <HeaderButton onClick={onClick}>
            <SettingsIcon src={iconSettings} className="t-settings-button"/>
            {menuComponent}
        </HeaderButton>
    );
};

export default Settings;
